/**
 * KB-META
 * Purpose: App component
 * Role: ui.component
 * EntryPoints: constructor(), addActivityListeners(), removeActivityListeners(), resetInactivityTimer()
 * Inputs: private authService:AuthService
 * Outputs: 
 * Validation: 
 * Dependencies: AuthService
 * Contracts: 
 * Auth&Privacy: auth:none; hipaa:none; pii:none
 * Observability: 
 * Router: shard=partner-portal-cura; H2=src/app.component; tags=ui
 * Owner: ; LastReviewed: 2025-08-25
 */
import { Component, OnInit, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AppLoaderOverlayComponent } from './app/components/app-loader-overlay/app-loader-overlay.component';
import { ToastModule } from 'primeng/toast';
import { MessageModule } from 'primeng/message';
import { AuthService } from './app/services/auth.service';

@Component({
    selector: 'app-root',
    standalone: true,
    imports: [RouterModule, ToastModule, MessageModule, AppLoaderOverlayComponent],
    template: `<app-loader-overlay></app-loader-overlay>
    <router-outlet></router-outlet>
    <p-toast></p-toast>
    <p-message></p-message>`
})
export class AppComponent implements OnInit, OnDestroy {
    private inactivityTimeout: any;
    private readonly AUTO_LOGOUT_MINUTES = 30;

    constructor(private authService: AuthService) {}

    ngOnInit() {
        this.resetInactivityTimer();
        this.addActivityListeners();
    }

    ngOnDestroy() {
        this.removeActivityListeners();
        clearTimeout(this.inactivityTimeout);
    }

    addActivityListeners() {
        window.addEventListener('mousemove', this.resetInactivityTimer.bind(this));
        window.addEventListener('keydown', this.resetInactivityTimer.bind(this));
        window.addEventListener('mousedown', this.resetInactivityTimer.bind(this));
        window.addEventListener('touchstart', this.resetInactivityTimer.bind(this));
        window.addEventListener('scroll', this.resetInactivityTimer.bind(this));
    }

    removeActivityListeners() {
        window.removeEventListener('mousemove', this.resetInactivityTimer.bind(this));
        window.removeEventListener('keydown', this.resetInactivityTimer.bind(this));
        window.removeEventListener('mousedown', this.resetInactivityTimer.bind(this));
        window.removeEventListener('touchstart', this.resetInactivityTimer.bind(this));
        window.removeEventListener('scroll', this.resetInactivityTimer.bind(this));
    }

    resetInactivityTimer() {
        clearTimeout(this.inactivityTimeout);
        this.inactivityTimeout = setTimeout(() => {
            this.authService.SignOut();
            // Optionally show a message/toast here
        }, this.AUTO_LOGOUT_MINUTES * 60 * 1000);
    }
}
